import React from 'react';
import { Key, History } from 'lucide-react';
import type { PasswordHistory } from '../../types';

interface PasswordGeneratorProps {
  passwordHistory: PasswordHistory[];
  onGeneratePassword: () => Promise<void>;
}

const PasswordGenerator: React.FC<PasswordGeneratorProps> = ({ passwordHistory, onGeneratePassword }) => {
  return (
    <div className="bg-white dark:bg-gray-800 overflow-hidden shadow rounded-lg">
      <div className="px-4 py-5 sm:p-6">
        <div className="flex items-center mb-4">
          <Key className="h-6 w-6 text-indigo-600 dark:text-indigo-400" />
          <h3 className="ml-3 text-lg font-medium text-gray-900 dark:text-white">Password Generator</h3>
        </div>
        <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">
          Generate a random password with 10 characters and an exclamation mark
        </p>
        <button
          onClick={onGeneratePassword}
          className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 dark:bg-indigo-500 dark:hover:bg-indigo-600"
        >
          Generate Password
        </button>

        {/* Password History */}
        {passwordHistory.length > 0 && (
          <div className="mt-4">
            <div className="flex items-center text-sm text-gray-500 dark:text-gray-400 mb-2">
              <History className="h-4 w-4 mr-1" />
              Recent Passwords:
            </div>
            <div className="space-y-2">
              {passwordHistory.map((item, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between p-2 bg-gray-50 dark:bg-gray-700 rounded"
                >
                  <code className="text-sm font-mono text-gray-600 dark:text-gray-300">
                    {item.password}
                  </code>
                  <span className="text-xs text-gray-400 dark:text-gray-500">
                    {new Date(item.created_at).toLocaleTimeString()}
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PasswordGenerator;